import { AxiosError } from "axios";
import { useApi } from "../hooks/useApi";

const api = useApi();

export async function createPaymentIntent(formData: { waiverRight: true; cguCgv: true; }) {
  try {
    const response = await api.post('/payment/payment-intent-creation', formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function confirmPaymentToApi(paymentIntentId: string): Promise<{ message: string }> {
  try {
    const response = await api.post('/payment/confirmation', {
      paymentIntentId: paymentIntentId,
    });

    return response.data;
  } catch (error) {
    // Vérifiez si l'erreur est une instance d'AxiosError
    if (error instanceof AxiosError) {
      if (error.response) {
        // Erreur HTTP avec réponse du serveur
        throw new Error(error.response.data?.message || "Erreur lors de la confirmation du paiement.");
      } else if (error.request) {
        // Erreur de requête sans réponse du serveur
        throw new Error("Le serveur n'a pas répondu. Veuillez réessayer plus tard.");
      }
    }

    // Pour toute autre erreur (non Axios)
    if (error instanceof Error) {
      throw new Error("Une erreur inattendue s'est produite. Veuillez réessayer.");
    }

    // Si le type de l'erreur est complètement inconnu
    throw new Error("Une erreur inconnue s'est produite.");
  }
}